import HttpClient from '@src/shared/services/base/http-client';
import MCPMarketEnvironmentDetection, {
  MCP_MARKET_ENVIRONMENT_COUNTRY_CODES,
} from '@src/shared/utils/market-environment-detection';

class OCFApiService extends HttpClient {
  constructor(baseURL: string, authHeaderName: string) {
    super(baseURL, authHeaderName);
  }

  public getCourierConnectionCode = (restaurantId: string) => {
    return this.instance.get(`/${restaurantId}/connectioncode`);
  };

  public refreshCourierConnectionCode = ({
    restaurantId,
    courierConnectionData,
  }: {
    restaurantId: any;
    courierConnectionData: any;
  }) => {
    return this.instance.put(`/${restaurantId}/connectioncode`, courierConnectionData);
  };
}

const getBaseUrl = () => {
  const { countryCode } = MCPMarketEnvironmentDetection.getMarketEnvironment();
  if (countryCode === MCP_MARKET_ENVIRONMENT_COUNTRY_CODES.UK) {
    return process.env.OCF_API_URL_EU_WEST as string;
  }
  return process.env.OCF_API_URL_EU_CENTRAL as string;
};

export default new OCFApiService(getBaseUrl(), 'X-Auth');
